export const concatenateUrls = (baseUrl: string, endpoint: string) =>
  baseUrl.replace(/\/api$/, "") + endpoint;
